<template>
    <div class="fhv-centent">
        <h4 class="title-topic">WIFI Security Settings {{$G_DEVICE_CFG.isWlBandSteering ? '' : '2.4GHz'}}</h4>
        <el-alert title="Some parameters in subRouter mode are forbidden to be modified!" type="warning" show-icon
        :closable="false" v-if="$G_DEVICE_CFG.isSubRouter"></el-alert>
        <el-form 
        :model="wlform"  
        label-width="180px" 
        label-position="left"
        class="fhv-form" 
        size="mini"
        :rules="formCheck" 
        ref="wlform"
        :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter"
        v-loading="getLoad"
        >
            <el-form-item label="Choose SSID :" v-if="!$G_DEVICE_CFG.isWlBandSteering">
                <el-select v-model="wlform.ssidIndex" style="width: 100%" placeholder="Please select SSID" @change="chooseSSID">
                    <el-option label="SSID1" value="0"></el-option>
                    <el-option label="SSID2" value="1" :disabled="$isTRUE"></el-option>
                    <el-option label="SSID3" value="2" :disabled="$isTRUE"></el-option>
                    <el-option label="SSID4" value="3" :disabled="$isTRUE"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Authentication :" >
                <el-select v-model="wlform.authMode" style="width: 100%" placeholder="Please select authentication mode">
                    <el-option label="OPEN" value="0"></el-option>
                    <el-option label="WEP" value="1"></el-option>
                    <el-option label="WPA PSK" value="2"></el-option>
                    <el-option label="WPA2 PSK" value="4"></el-option>
                    <el-option label="WPA PSK/WPA2 PSK MIXED" value="6"></el-option>
                </el-select>
            </el-form-item>
            <!-- WEP -->
            <div v-if="wlform.authMode === '1'">
                <el-form-item label="Encryption Mode:" >
                    <el-select v-model="wlform.wep.authType" style="width: 100%" placeholder="Please select Encryption Mode">
                        <el-option label="Open" value="0"></el-option>
                        <el-option label="Shared" value="1"></el-option>
                        <el-option label="Both" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Key Length:" prop="wep.length">
                    <el-radio-group v-model="wlform.wep.length">
                        <el-radio label="1">64bits</el-radio>
                        <el-radio label="2">128bits</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Key Format:" prop="wep.keyType">
                    <el-radio-group v-model="wlform.wep.keyType">
                        <el-radio label="1">ASCII ({{wlform.wep.length === '1' ? '5': '13'}} characters)</el-radio>
                        <el-radio label="2">Hex ({{wlform.wep.length === '1' ? '10': '26'}} characters)</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="WEP Preshare key :" prop="wep.key">
                    <el-input :type="isShowKey ? 'text' : 'password'" v-model="wlform.wep.key" auto-complete="new-password">
                        <i slot="suffix" class="el-input__icon glyphicon  fhv-password" 
                        :class="[isShowKey ? 'glyphicon-eye-close' : 'glyphicon-eye-open']"
                        @click="isShowKey = !isShowKey"></i>
                    </el-input>
                </el-form-item>
            </div>
            <div v-if="parseInt(wlform.authMode) > 1">
                <el-form-item label="Encryption Mode:" >
                    <el-select v-model="wlform.authAlgorithm" style="width: 100%" placeholder="Please select Encryption mode">
                        <el-option label="AES" value="1"></el-option>
                        <el-option label="TKIP" value="2"></el-option>
                        <el-option label="TKIP + AES" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="WPA Re-Autencation :" prop="wpaReAutencation" v-if="$isTRUE">
                    <el-input v-model.number="wlform.wpaReAutencation"></el-input>
                </el-form-item>
                <el-form-item label="WPA Preshare key :" prop="ssidPassword">
                    <el-input :type="isShowKey ? 'text' : 'password'" v-model.trim="wlform.ssidPassword" auto-complete="new-password">
                        <i slot="suffix" class="el-input__icon glyphicon  fhv-password" 
                        :class="[isShowKey ? 'glyphicon-eye-close' : 'glyphicon-eye-open']"
                        @click="isShowKey = !isShowKey"></i>
                    </el-input>
                </el-form-item>
            </div>
            
            <el-form-item>
                <el-button type="primary" @click="apply">Apply</el-button>
                <el-button type="primary" @click="refresh">Refresh</el-button>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>
import validator from 'validator'
import sizeof from '@/util/jsCharLength.js'

export default {
    data(){
       return {
           isShowKey:false,
           getLoad:false,
           wlform:{
               ssidPassword:"",
               authAlgorithm:"3",
               authMode:"6",
               wpaReAutencation: 1800,
               ssidIndex:"0",
               wep:{
                   authType:'2',
                   keyType:'1',
                   length:'1',
                   key:''
               }
           },
           formCheck:{
                wpaReAutencation:[
                    { required: true, message: 'Please enter WPA Re-Autencation', trigger: 'blur' },
                    { type: 'number', min: 0, max: 3600, message: 'WPA Re-Autencation range is [0-3600].', trigger: 'blur' }
                ],
                ssidPassword:[
                    { required: true, message: 'Please enter WPA Preshare key', trigger: 'blur' },
                    { 
                        validator:(rule, value, callback) => {
                            if(sizeof(value,'utf-8') > 64 || sizeof(value,'utf-8') < 8)
                                callback(new Error("WPA Preshare key must 8~64 byte"))
                            else
                                callback()
                        },
                        trigger: 'blur' 
                    }
                ],
                wep:{
                    length:[
                        { required: true, message: 'Please select Key Length', trigger: 'change' }
                    ],
                    keyType:[
                        { required: true, message: 'Please select Key Format', trigger: 'change' }
                    ],
                    key:[
                        { required: true, message: 'Please enter WEP key', trigger: 'blur' },
                        {
                        validator:(rule, value, callback) => {
                            const len = this.wlform.wep.length
                            const format = this.wlform.wep.keyType
                            let regexp = len === '1' 
                                         ? format === '1' ? /^[a-zA-Z0-9]{5}$/ : /^[a-fA-F0-9]{10}$/
                                         : format === '1' ? /^[a-zA-Z0-9]{13}$/ : /^[a-fA-F0-9]{26}$/
                            
                            let errMsg = len === '1' 
                                         ? format === '1' 
                                         ? 'WEP key must be 5 letter and number [0-9 a-z A-Z]' 
                                         : 'WEP key must be 10 hex [0-9 a-f A-F]'
                                         : format === '1' 
                                         ? 'WEP key must be 13 letter and number'  
                                         : 'WEP key must be 26 hex [0-9 a-f A-F]'

                            if(!regexp.test(value))
                                callback(new Error(errMsg))
                            else
                                callback()
                        },
                        trigger: 'blur'
                    }
                    ]
                }
           } 
       }
    },
    beforeMount(){
        this.getData()
    },
    methods:{
        getData(){
            this.getLoad = true
            axios
            .post("/boafrm/fhSecurityWlan",{
                CmdType:"GET_SECURITY_WLAN",
                ssidIndex:this.wlform.ssidIndex
            })
            .then((response)=>{
                this.getLoad = false
                if(response.data.ret == '0')
                {
                    this.wlform.ssidPassword = response.data.ssidPassword
                    if(response.data.authAlgorithm == 0) response.data.authAlgorithm = '3'
                    this.wlform.authAlgorithm = '' + response.data.authAlgorithm
                    this.wlform.authMode = '' + response.data.authMode
                    this.wlform.wpaReAutencation = response.data.wpaReAutencation
                    if(response.data.authMode === 1)
                    {// WEP
                        this.wlform.wep.length = '' + response.data.wep.length
                        this.wlform.wep.authType = '' + response.data.wep.authType
                        this.wlform.wep.keyType = '' + response.data.wep.keyType
                        this.wlform.wep.key = response.data.wep.key
                    }
                }
            })
        },
        setData(){
            const loadingInstance = this.$loading({lock: true})
            let postData = {
                CmdType:"SET_SECURITY_WLAN",
                ssidIndex:this.wlform.ssidIndex,
                ssidPassword:this.wlform.ssidPassword,
                authAlgorithm:this.wlform.authAlgorithm,
                authMode:this.wlform.authMode,
                wpaReAutencation:this.wlform.wpaReAutencation,
            }

            if(this.wlform.authMode === '1')
                postData.wep = this.wlform.wep

            axios
            .post("/boafrm/fhSecurityWlan",postData)
            .then((response)=>{
                setTimeout(()=>{
                    loadingInstance.close()
                    if(response.data.ret == '0')
                        this.$message.success("Configuration is successful!")
                    else
                        this.$message.error("Configuration failed!")
                },6000)
            })
        },
        apply(){
            this.$refs['wlform'].validate((valid) => {
                if (valid) {
                    this.setData()
                } else {
                    return false
                }
            })
        },
        refresh(){
            this.isShowKey = false
            this.$refs['wlform'].resetFields()
            this.getData()
        },
        chooseSSID(){
            this.$refs['wlform'].resetFields()
            this.getData()
        },
    },
}
</script>

<style>
.fhv-password{
    cursor:pointer
}
</style>




